export default function Benefits() {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-orange-50 to-rose-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            🌟 Beneficios de<br />
            "El poder de ser yo"
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-800 max-w-3xl mx-auto leading-relaxed font-medium">
            Este libro promueve una crianza consciente, donde la prioridad es la conexión emocional, el respeto y la comprensión.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12 md:mb-16">
          {/* Benefit 1 */}
          <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all text-center group hover:scale-105">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-emerald-100 rounded-full text-emerald-600 text-3xl sm:text-4xl group-hover:scale-110 transition-transform">
              <i className="ri-book-open-line"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
              Acceso inmediato
            </h3>
            <p className="text-gray-800 leading-relaxed text-sm sm:text-base font-medium">
              📥 Descarga instantánea después de la compra. Comienza a leer de inmediato.
            </p>
          </div>

          {/* Benefit 2 */}
          <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all text-center group hover:scale-105">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-orange-100 rounded-full text-orange-600 text-3xl sm:text-4xl group-hover:scale-110 transition-transform">
              <i className="ri-smartphone-line"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
              Formato digital
            </h3>
            <p className="text-gray-800 leading-relaxed text-sm sm:text-base font-medium">
              📱 Puedes usarlo en cualquier dispositivo: tablet, móvil o computadora.
            </p>
          </div>

          {/* Benefit 3 */}
          <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all text-center group hover:scale-105">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-rose-100 rounded-full text-rose-600 text-3xl sm:text-4xl group-hover:scale-110 transition-transform">
              <i className="ri-group-2-line"></i>
            </div>
            <h3 className="font-serif text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
              Para toda la familia
            </h3>
            <p className="text-gray-800 leading-relaxed text-sm sm:text-base font-medium">
              👨‍👩‍👧 Ideal para leer y trabajar en familia. Experiencia compartida.
            </p>
          </div>
        </div>

        {/* Price Highlight */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl sm:rounded-3xl p-8 sm:p-10 md:p-12 text-center text-white shadow-2xl">
          <p className="text-base sm:text-lg font-medium mb-2 opacity-95">Precio especial de lanzamiento</p>
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <span className="text-5xl sm:text-6xl md:text-7xl font-bold">$9</span>
            <span className="text-xl sm:text-2xl font-medium">USD</span>
          </div>
          <p className="text-base sm:text-lg md:text-xl opacity-95 mb-6 sm:mb-8 font-medium">
            Una inversión pequeña para un impacto profundo en la relación con tus hijos
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 text-left max-w-2xl mx-auto">
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <i className="ri-check-line text-xl sm:text-2xl"></i>
              <span className="text-sm sm:text-base font-medium">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <i className="ri-check-line text-xl sm:text-2xl"></i>
              <span className="text-sm sm:text-base font-medium">Sin suscripciones</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <i className="ri-check-line text-xl sm:text-2xl"></i>
              <span className="text-sm sm:text-base font-medium">Actualizaciones incluidas</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
